<template>
  <v-container v-if="capacitadorToUpdate">
    <v-row>
      <v-col cols="12">
        <v-btn text class="ui-back-btn" @click="$router.go(-1)">
          <v-icon>mdi-arrow-left</v-icon>
          Volver
        </v-btn>
      </v-col>
      <v-col cols="12" lg="6" offset-lg="3">
        <v-card class="ui-module-card ui-module-fade-in-up" color="primary">
          <v-card-title class="ui-module-titlebar font-weight-bold justify-center">Editar capacitador</v-card-title>
          <v-card-text>
            <v-form v-model="trainerForm">
              <v-container>
                <v-row>
                  <v-col cols="12" class="d-flex justify-center pb-2">
                    <v-btn-toggle
                      v-model="tipoCapacitador"
                      mandatory
                      color="secondary"
                      rounded
                      class="ui-toggle-switch"
                    >
                      <v-btn value="capacitador" class="px-6">Capacitador</v-btn>
                      <v-btn value="institucion" class="px-6">Institución responsable</v-btn>
                    </v-btn-toggle>
                  </v-col>
                  <template v-if="tipoCapacitador === 'capacitador'">
                    <v-col cols="12">
                      <v-text-field
                        class="ui-form-field"
                        v-model="capacitadorToUpdate.nombre"
                        rounded
                        filled
                        dense
                        background-color="transparent"
                        color="secondary"
                        :rules="nameRules"
                      >
                        <template v-slot:label>Nombre <span class="red--text">*</span> </template>
                      </v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        class="ui-form-field"
                        v-model="capacitadorToUpdate.segundoNombre"
                        label="Segundo nombre"
                        rounded
                        filled
                        dense
                        background-color="transparent"
                        color="secondary"
                      >
                      </v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        class="ui-form-field"
                        v-model="capacitadorToUpdate.apaterno"
                        rounded
                        filled
                        dense
                        background-color="transparent"
                        color="secondary"
                        :rules="nameRules"
                      >
                        <template v-slot:label>Apellido paterno <span class="red--text">*</span> </template>
                      </v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        class="ui-form-field"
                        v-model="capacitadorToUpdate.amaterno"
                        rounded
                        filled
                        dense
                        background-color="transparent"
                        color="secondary"
                        :rules="nameRules"
                      >
                        <template v-slot:label>Apellido materno <span class="red--text">*</span> </template>
                      </v-text-field>
                    </v-col>
                  </template>
                  <template v-else>
                    <v-col cols="12">
                      <v-text-field
                        class="ui-form-field"
                        v-model="capacitadorToUpdate.nombre"
                        rounded
                        filled
                        dense
                        background-color="transparent"
                        color="secondary"
                        :rules="nameRules"
                      >
                        <template v-slot:label>Nombre de la institución <span class="red--text">*</span> </template>
                      </v-text-field>
                    </v-col>
                  </template>
                  <v-col cols="12">
                    <v-file-input
                      class="ui-form-field"
                      v-model="file"
                      label="Adjuntar certificado o título"
                      persistent-hint
                      rounded
                      filled
                      background-color="transparent"
                      color="secondary"
                      dense
                    >
                    </v-file-input>
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
          </v-card-text>
          <v-card-actions class="justify-center pb-8 ui-module-actions">
            <v-btn
              color="secondary"
              class="primary--text px-8 ui-module-btn-solid"
              :disabled="!trainerForm || loading"
              v-on:click="triggerUpdateTrainer()"
            >
              Editar capacitador
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'

export default {
  props: {
    id: {
      type: Number,
    },
  },

  async mounted() {
    this.SET_CAPACITADOR_TO_UPDATE(this.id)
  },

  data() {
    return {
      loading: false,
      trainerForm: false,
      file: null,
      tipoCapacitador: 'capacitador',

      nameRules: [(v) => !!v || 'Este campo es requerido.'],
    }
  },

  computed: {
    ...mapGetters('capacitador', {
      capacitadorToUpdate: 'getCapacitadorToUpdate',
    }),
  },

  watch: {
    capacitadorToUpdate: {
      handler(value) {
        if (!value) {
          return
        }

        this.tipoCapacitador = this.isInstitucion(value) ? 'institucion' : 'capacitador'
      },
      immediate: true,
    },
  },

  methods: {
    ...mapActions('capacitador', ['updateCapacitador', 'fetchCapacitadores']),
    ...mapActions('cursoProgramado', ['fetchCursosProgramados']),
    ...mapActions('cursoAsignado', ['fetchCursosAsignados']),
    ...mapMutations('capacitador', ['SET_CAPACITADOR_TO_UPDATE']),

    triggerUpdateTrainer: async function () {
      this.loading = true

      if (this.tipoCapacitador === 'institucion') {
        this.capacitadorToUpdate.segundoNombre = ''
        this.capacitadorToUpdate.apaterno = '-'
        this.capacitadorToUpdate.amaterno = '-'
      }

      if (this.file) {
        this.capacitadorToUpdate.certificado = this.file.name
      }

      await this.updateCapacitador({
        capacitador: this.capacitadorToUpdate,
        file: this.file,
      })

      await this.fetchCapacitadores()
      await this.fetchCursosProgramados()
      await this.fetchCursosAsignados()
      this.$router.replace('/profesionalizacion/capacitadores')

      this.loading = false
    },

    isInstitucion(capacitador) {
      return capacitador.apaterno === '-' && capacitador.amaterno === '-'
    },
  },
}
</script>

<style scoped>
.ui-back-btn {
  color: #26de81 !important;
  text-transform: none !important;
  font-weight: 600 !important;
}

::v-deep .ui-toggle-switch {
  background: rgba(26, 46, 36, 0.6) !important;
  border: 1px solid rgba(0, 210, 160, 0.2) !important;
  border-radius: 12px !important;
}

::v-deep .ui-toggle-switch .v-btn {
  border-radius: 10px !important;
  text-transform: none !important;
  font-weight: 600 !important;
}

::v-deep .ui-toggle-switch .v-btn--active {
  background: rgba(0, 210, 160, 0.18) !important;
}

::v-deep .ui-form-field .v-input__slot {
  border-radius: 12px !important;
  border: 1px solid rgba(0, 210, 160, 0.25) !important;
  background: rgba(16, 16, 30, 0.35) !important;
  transition: all 0.3s ease !important;
}

::v-deep .ui-form-field .v-input__slot:hover {
  border-color: rgba(0, 210, 160, 0.45) !important;
}

::v-deep .ui-form-field .v-input__control {
  background: transparent !important;
  border-radius: 12px;
  border: none !important;
  box-shadow: none !important;
}

::v-deep .ui-form-field.v-input--is-focused .v-input__control {
  border: none !important;
  box-shadow: none !important;
}

::v-deep .ui-form-field input,
::v-deep .ui-form-field .v-file-input__text,
::v-deep .ui-form-field .mdi-paperclip {
  color: #e0e0e0 !important;
}

::v-deep .ui-form-field .v-label {
  color: rgba(224, 224, 224, 0.7) !important;
}

::v-deep .ui-form-field.v-input--is-focused .v-label,
::v-deep .ui-form-field .v-label--active {
  color: #26de81 !important;
}

::v-deep .ui-form-field .v-text-field__details,
::v-deep .ui-form-field .v-messages__message {
  color: rgba(224, 224, 224, 0.55) !important;
}

::v-deep .ui-module-actions .v-btn {
  border-radius: 12px !important;
  text-transform: none !important;
  font-weight: 600 !important;
  transition: all 0.3s ease;
}

::v-deep .ui-module-actions .ui-module-btn-solid {
  background: linear-gradient(135deg, #00d2a0 0%, #26de81 100%) !important;
  color: #062118 !important;
  box-shadow: 0 8px 24px rgba(0, 210, 160, 0.28) !important;
}

::v-deep .ui-module-actions .v-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 210, 160, 0.25) !important;
}

.red--text {
  color: #ff5252 !important;
}
</style>
